module.exports = __webpack_public_path__ + "img/kr-product-agency-card4-3.434cc14.png";